export const APPLY_FILTERS = 'APPLY_FILTERS'
